import { useState } from 'react';
import { UPLOAD_STATUS } from 'core/constants';
import { uploadActivityBlockResponseFile } from '../api';

export const useFileUploader = () => {
  const [uploadStatus, setUploadStatus] = useState(UPLOAD_STATUS.IDLE);
  const [error, setError] = useState();

  const uploadFile = async (activityResponseId, blockId, file) => {
    setUploadStatus(UPLOAD_STATUS.UPLOADING);
    try {
      const response = await uploadActivityBlockResponseFile(
        file,
        activityResponseId,
        blockId
      );

      setUploadStatus(UPLOAD_STATUS.SUCCESS);
      return { fileKey: response.file_key };
    } catch (error) {
      setUploadStatus(UPLOAD_STATUS.ERROR);
      setError(error);
    }
  };

  return {
    uploadStatus,
    uploadFile,
    uploadError: error,
  };
};
